import type { Municipio, Permiso } from '@/api/modelos'

/**
 * Si el usuario tiene el permiso en ESE municipio.
 *
 * Sirve solo para ocultar lo que no corresponde: la autorizacion de verdad la
 * hace el servidor en cada endpoint.
 */
export function tienePermiso(municipio: Municipio | null | undefined, permiso: Permiso): boolean {
  return municipio?.permisos.includes(permiso) ?? false
}

/** Basta uno de la lista. */
export function tieneAlgunPermiso(
  municipio: Municipio | null | undefined,
  permisos: readonly Permiso[],
): boolean {
  return permisos.some((permiso) => tienePermiso(municipio, permiso))
}

export function buscarMunicipio(
  municipios: Municipio[] | undefined,
  slug: string | undefined,
): Municipio | null {
  return municipios?.find((municipio) => municipio.slug === slug) ?? null
}
